import { JdsTag } from '../../../components/jds/JdsTag';
import { ItemStatusEnum } from '../../../api/payments/items/domain/enum';

const ITEM_STATUS_BADGES = {
  [ItemStatusEnum.ACTIVE]: { label: 'Ativo', color: 'success' },
  [ItemStatusEnum.INACTIVE]: { label: 'Desativado', color: 'error' },
};

export function ItemStatusBadge({ item }) {
  const badge =
    ITEM_STATUS_BADGES[item?.statusType] ||
    ITEM_STATUS_BADGES[ItemStatusEnum.INACTIVE];

  return <JdsTag label={badge.label} color={badge.color} dot />;
}
